// The canonical form of a collaborator function name: format characters (\p{Cf}: zero-width
// space/joiners, BOM, ...) and control characters (\p{Cc}: tab, newline) removed FIRST, then Unicode
// NFC, then trimmed (an invisible character between a letter and its accent would otherwise block
// the composition). The API stores and compares this form (atoms/validators.ts
// normalizeFunctionName); the form applies it first so the inline errors and the submitted name agree
// with the server. Accents stay distinct.
export function normalizeFunctionName(value: string): string {
  return value
    .replace(/[\p{Cf}\p{Cc}]/gu, '')
    .normalize('NFC')
    .trim()
}

// Length in characters (code points), the unit of the 60-character limit; an emoji counts once
export function functionNameLength(name: string): number {
  return [...name].length
}
